import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'stringToDate',
})
export class StringToDatePipe implements PipeTransform {
  constructor(
    private datePipe: DatePipe,
    private translateService: TranslateService
  ) {}

  /**
   * CLA le 15/03/2019
   * Introduction du test si la valeur n'est pas définie "(undefined)",
   * la chaîne doit être vide. Avant, la date du jour était affichée
   * dans ce cas-là.
  */
  transform(value: string, format?: string): any {
    var result="";
    if (value) {
      // Moment match the ISO 8601 format required
      result=this.datePipe.transform(
        moment(value).toDate(),
        format || 'longDate',
        undefined,
        this.translateService.currentLang
      );
    }
    return result;
  }
}
